// shared/ui/ImagenesDetalleCard.jsx  (presentacional: tarjeta «Imágenes» del detalle; compartida por capacitaciones y visitas)
import React from 'react';
import { CircularProgress } from '@mui/material';
import SectionCard from './SectionCard.jsx';
import PillButton from './PillButton.jsx';
import EmptyBox from './EmptyBox.jsx';
import ImagenGuardada from './ImagenGuardada.jsx';
import ImagenPendiente from './ImagenPendiente.jsx';
import { MSG_LIMITE_ALCANZADO, tituloImagenes, DISPARADOR_ELIMINAR, textoBotonEliminar, textoPendientesEliminar } from '../domain/media';

const ImagenesDetalleCard = ({
  imagenes,
  subtitle,
  alt,
  totalImagenes = 0,
  pendientes = [],
  subiendoImagenes = false,
  limiteAlcanzado = false,
  modoEliminar = false,
  eliminando = false,
  saliendo = {},
  onAddImages,
  onEntrarModoEliminar,
  onCancelarModoEliminar,
  onAplicarEliminacion,
  onEliminarImagen,
  onDeshacerEliminar,
  onQuitarPendiente,
  onReintentarPendiente,
  onPendienteListo,
}) => {
  const inputRef = React.useRef(null);
  const marcadas = imagenes.filter(media => media.eliminacion).length;
  const porEliminar = imagenes.filter(media => media.eliminacion && media.eliminacion.estado !== 'deleting').length;
  const bloqueado = subiendoImagenes || eliminando;

  return (
    <SectionCard
      title={tituloImagenes(totalImagenes)}
      subtitle={
        <>
          {subtitle}
          <div role="status" aria-live="polite" style={{ color: '#6c757d', fontSize: 12 }}>
            {textoPendientesEliminar(marcadas, DISPARADOR_ELIMINAR)}
          </div>
        </>
      }
      actions={
        <span className="d-flex" style={{ gap: 10 }}>
          {!modoEliminar && (
            <span
              title={limiteAlcanzado ? MSG_LIMITE_ALCANZADO : undefined}
              style={{ display: 'inline-block', cursor: bloqueado || limiteAlcanzado ? 'default' : undefined }}>
              <PillButton
                icon={subiendoImagenes ? undefined : 'fa-plus'}
                onClick={() => inputRef.current && inputRef.current.click()}
                disabled={bloqueado || limiteAlcanzado}
                style={bloqueado || limiteAlcanzado ? { pointerEvents: 'none' } : undefined}>
                {subiendoImagenes && <CircularProgress size={14} color="inherit" aria-hidden="true" style={{ marginRight: 8 }} />}
                {subiendoImagenes ? 'Subiendo…' : 'Agregar Imagen'}
              </PillButton>
            </span>
          )}
          {!modoEliminar && (
            <PillButton icon="fa-trash" danger disabled={imagenes.length === 0 || subiendoImagenes} onClick={onEntrarModoEliminar}>
              Eliminar Imagen
            </PillButton>
          )}
          {modoEliminar && (
            <>
              <PillButton onClick={onCancelarModoEliminar} disabled={eliminando}>
                Cancelar
              </PillButton>
              {(porEliminar > 0 || eliminando) && (
                <PillButton
                  icon={eliminando ? 'fa-spinner fa-spin' : 'fa-trash'}
                  danger
                  disabled={eliminando}
                  onClick={onAplicarEliminacion}>
                  {eliminando ? 'Eliminando…' : textoBotonEliminar(porEliminar)}
                </PillButton>
              )}
            </>
          )}
        </span>
      }>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept=".jpg,.jpeg,.png,image/jpeg,image/png"
        style={{ display: 'none' }}
        onChange={event => {
          const files = Array.from(event.target.files || []);
          event.target.value = '';
          if (files.length) onAddImages(files);
        }}
      />
      {imagenes.length === 0 && pendientes.length === 0 ? (
        <EmptyBox>Aún no hay imágenes</EmptyBox>
      ) : (
        <div className="d-flex flex-wrap" style={{ gap: 12 }}>
          {imagenes.map(media => (
            <ImagenGuardada
              key={media.uuid || media.id}
              media={media}
              alt={alt}
              size={150}
              abrir={!modoEliminar}
              canDelete={modoEliminar}
              disabled={eliminando}
              saliendo={!!saliendo[media.uuid]}
              disparador={DISPARADOR_ELIMINAR}
              onDelete={onEliminarImagen}
              onUndo={onDeshacerEliminar}
            />
          ))}
          {pendientes.map(item => (
            <ImagenPendiente
              key={item.uuid}
              item={item}
              size={150}
              disabled={eliminando}
              onRemove={onQuitarPendiente}
              onRetry={item => onReintentarPendiente(item.uuid)}
              onDone={onPendienteListo}
            />
          ))}
        </div>
      )}
    </SectionCard>
  );
};

export default ImagenesDetalleCard;
